import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IFeatureSetMetaDataStyles {
  root?: IStyle;
  description?: IStyle;
  descriptionText?: IStyle;
  list?: IStyle;
  pivotContainer?: IStyle;
  search?: IStyle;
}

export interface IFeatureSetMetaDataClassNames {
  root: string;
  description?: string;
  descriptionText?: string;
  list?: string;
  pivotContainer?: string;
  search?: string;
}

export const featureSetMetaDataStylesDefault = (theme: IH2OTheme): Partial<IFeatureSetMetaDataStyles> => ({
  root: {
    marginTop: 1,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  description: {
    color: theme.semanticColors?.textSecondary,
    display: 'flex',
    justifyContent: 'space-between',
  },
  list: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  pivotContainer: {
    flex: 1,
    minHeight: 0,
  },
  search: {
    flex: 1,
    marginLeft: 16,
    maxWidth: 611,
    marginBottom: 8,
  },
  descriptionText: {
    marginTop: 8,
    marginBottom: 8,
  },
});
